import React from "react";

/**
 * Small inline badge(s) that identify a card profile's role.
 *
 * "Default" tracks the profile's `isDefault` flag (not its name), so it always
 * follows whichever profile is currently the company default. "Inherited" marks
 * a profile pushed down from the parent company (`sourceProfileId` set).
 *
 * Use `tags` to limit which badges render in a context that already has a
 * dedicated column for one of them (e.g. the Card Profiles table).
 */
const BADGES = {
  default: { label: "Default", className: "bg-green-100 text-green-800" },
  inherited: { label: "Inherited", className: "bg-blue-100 text-blue-800" },
};

const CardProfileTag = ({
  profile,
  tags = ["default", "inherited"],
  className = "",
}) => {
  if (!profile) return null;

  const active = [];
  if (tags.includes("default") && profile.isDefault) active.push("default");
  if (tags.includes("inherited") && profile.sourceProfileId)
    active.push("inherited");

  if (active.length === 0) return null;

  return (
    <>
      {active.map((key) => (
        <span
          key={key}
          className={`ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${BADGES[key].className} ${className}`}
        >
          {BADGES[key].label}
        </span>
      ))}
    </>
  );
};

export default CardProfileTag;
